import { useEffect } from "react"

export default function usePlotlyResizeObserver({
  containerRef,
  isInitializedRef,
  onResize,
}) {
  useEffect(() => {
    const container = containerRef.current
    if (!container || typeof ResizeObserver === "undefined") {
      return
    }

    // Coalesce bursts of resize notifications (e.g. a panel drag firing ~60x/sec) into one render per frame.
    // onResize runs the full themed render, which recomputes the width-based showlegend + legend placement itself.
    let rafId = null
    const runResize = () => {
      rafId = null
      const current = containerRef.current
      if (!current || !isInitializedRef.current || !current.isConnected) {
        return
      }
      try {
        onResize(current)
      } catch {
        // no-op on error
      }
    }

    const ro = new ResizeObserver(() => {
      if (rafId == null) {
        rafId = requestAnimationFrame(runResize)
      }
    })
    ro.observe(container)
    return () => {
      if (rafId != null) {
        cancelAnimationFrame(rafId)
      }
      ro.disconnect()
    }
  }, [containerRef, isInitializedRef, onResize])
}
